import { getCookieConsentValue } from "react-cookie-consent";

export const ANALYTICS_CONSENT_COOKIE = "studyradar_analytics_consent";

export const analyticsConfig = {
  gaMeasurementId: process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || "",
  metaPixelId: process.env.REACT_APP_META_PIXEL_ID?.trim() || "",
  redditPixelId: process.env.REACT_APP_REDDIT_PIXEL_ID?.trim() || "",
};

export const { gaMeasurementId, metaPixelId, redditPixelId } = analyticsConfig;

export function hasAnalyticsConsent() {
  return getCookieConsentValue(ANALYTICS_CONSENT_COOKIE) === "true";
}
